var swiper = new Swiper(".mySwiperProfessional", {
    slidesPerView: "1",
    spaceBetween: 30,
    pagination: {
        el: ".imagecarousel-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        500: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 2,
        },
        992: {
            slidesPerView: 3,
        },
    },
});


// Function to apply inline height for mobile/tablet only
function setSwiperSlideHeight() {
    var swiperSlides = document.querySelectorAll('.mySwiperProfessional .swiper-slide');
    var windowWidth = window.innerWidth;

    swiperSlides.forEach(function(slide) {
        var heightMobile = slide.getAttribute('data-height-mobile');
        var heightTablet = slide.getAttribute('data-height-tablet');
        var heightAutoDesktop = slide.getAttribute('data-height-auto-desktop') === "true"; // Boolean from checkbox
        var heightDesktopCustom = slide.getAttribute('data-height-desktop-custom');

        if (windowWidth <= 500) {
            // Apply mobile height
            slide.style.height = heightMobile + 'rem';
        } else if (windowWidth <= 991) {
            // Apply tablet height
            slide.style.height = heightTablet + 'rem';
        } else {
            // Apply desktop height based on checkbox
            if (heightAutoDesktop) {
                slide.style.height = 'auto';
            } else {
                slide.style.height = heightDesktopCustom + 'rem';
            }
        }
    });
}

// Run on page load
setSwiperSlideHeight();

// Run on window resize
window.addEventListener('resize', setSwiperSlideHeight);